<template>
	<v-container>
		<v-window disabled  v-model="step">
			<v-window-item v-for="(item, index) in elements" :key="index" :value="index">
				<component v-bind:is="getComponent(item.component)"
					:ref="item.code"
					v-model="elements[index]"
					max-width="600"
					:visible="index==step"
				></component>
			</v-window-item>
		</v-window>

		<v-navigation-drawer
			v-model="drawer"
			:location="$vuetify.display.mobile ? 'bottom' : undefined"
			temporary
		>
			<v-list density="compact">
				<v-list-subheader>Елементи діалогу</v-list-subheader>

				<v-list-item v-for="(item, index) in elements" :key="index"
					color="primary"
					@click="setStep(index)"
				>
					<!-- <template v-slot:prepend>
						<v-icon :icon="item.icon"></v-icon>
					</template> -->

					<v-list-item-title v-text="item.name"></v-list-item-title>

					<template v-slot:append>
						<v-icon v-if="item?.errors?.length" color="error">mdi-alert-circle</v-icon>
						<!-- <span v-else-if="getImageCount(item.code) > 0">{{ getImageCount(item.code) }}</span> -->
						<span v-else-if="getImageCount(item) > 0">{{ getImageCount(item) }}</span>
					</template>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-bottom-navigation grow :elevation="1">
			<v-btn v-if="elements.length > 1" @click="drawer=!drawer">
				<v-icon>mdi-menu</v-icon>
				<span>{{ step+1 }} / {{ elements.length }}</span>
			</v-btn>

			<v-spacer></v-spacer>

			<v-btn v-if="step > 0" @click="onPrevious" value="recent">
				<v-icon>mdi-arrow-left-thick</v-icon>
				<span>{{ $filters.Translate('btn.previous') }}</span>
			</v-btn>

			<v-btn v-if="step < Object.keys(elements).length - 1" @click="onNext" value="nearby">
				<v-icon>mdi-arrow-right-thick</v-icon>
				<span>{{ $filters.Translate('btn.next') }}</span>
			</v-btn>

			<v-spacer></v-spacer>

			<v-btn @click="onLog" style="visibility: hidden;">
				<v-icon>mdi-math-log</v-icon>
				<span>Log</span>
			</v-btn>

			<!-- <v-btn @click="setStep('Summary')" :disabled="disabledSummary">
				<v-icon>mdi-check-all</v-icon>
				<span>{{ $filters.Translate('btn.summary') }}</span>
			</v-btn> -->
		</v-bottom-navigation>

		<v-overlay v-model="loading"  class="d-flex justify-center align-center">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import zOferta from '@/components/Oferta'

export default {
	name: 'Claim',
	components: { zOferta },

	data: () => ({
		drawer: false,
		loading: false,
	}),

	computed: {
		...mapGetters('Claim', [ 'claim', 'elements', 'step', 'windows' ]),

		/* visibleSummary() {
			return false //Тимчасово. Для прискориного тестування
			return !this.data.identity
		}, */

		/* disabledSummary() {
			return false //Тимчасово. Для прискориного тестування
			return !this.data.identity
		}, */

		disabledMenu() {
			return false //Тимчасово. Для прискориного тестування
			return !this.data.identity
		},
	},

	created() {
		//console.log(this.$options.name,  'created', 'direction', this.direction) 
		//console.log(this.$options.name,  'created', 'router', this.$router) 

		const requireComponent = require.context("@/views/components", false, /[A-Z]\w+\.(vue|js)$/);
		requireComponent.keys().forEach(fileName => {
			const componentConfig = requireComponent(fileName);
			const componentName = `z${fileName.split("/").pop().split(".")[0]}`;
			this.$options.components[componentName] = componentConfig.default;
		});

		//console.log(this.$options.name,  'created')

		//this.getDialog()
		
		this.find()
	},

	watch: {
		step(newValue, oldValue) {
			this.validate();

			//console.log(this.$options.name, 'step', 'val', oldValue, newValue )
			//console.log(this.$options.name, 'step', 'windows', this.windows )

			const element = this.elements[newValue];
			if(element) {
				switch(element?.code) {
					case 'Summary': 
						this.checking();
					break; 
				}
			}
		},
	},

	methods: {
		...mapActions(['showMessage']),
		...mapActions('Claim', ['setClaim', 'setStep', 'previousStep', 'nextStep']),

		onLog() {
			//console.log(this.$options.name, 'onLog','history.state', history.state)
			//console.log(this.$options.name, 'onLog','direction', this.direction)
			//console.log(this.$options.name, 'onLog','windows', this.windows)
			console.log(this.$options.name, 'onLog','claim', this.claim)
		},

		getComponent(code) {
			const name = `z${code}`
			return this.$options.components[name] ? name : 'zDefault'
		},

		find() {
			var that = this
			
			//let $url = this.claim?.number ? `/claim/${this.claim.number}` : `/claim`;
			let $url = `/claim`;

			this.loading = true
			return axios.get($url).then(response => {
				//console.log(that.$options.name, 'getDialog', 'response.data', response.data)

				that.setClaim(response.data)
			}, error => {
				//console.log('error', error)
				this.showMessage(error)
			}).finally(() => {
				this.loading = false
			});
		},

		save(element) {
			//console.log(this.$options.name, 'save','element', element)
			//console.log(this.$options.name, 'save','claim', this.claim)

			if(element) {
				/* if(window.component == 'Picture') {
					return this.savePicture(window)
				} */

				if(element.component == 'Document') {
					return this.uploadDocument(element)
				}

				let params = {
					component: element.component
				}
				
				var that = this
				this.loading = true
				return axios.post(`/claim`, this.claim, {params: params}).then(response => {
					//console.log(that.$options.name, 'onNext','response.data', response.data)
					element.changed = false
				}, error => {
					console.log('error', error)
					this.showMessage(error)
				}).finally(() => {
					this.loading = false
				});
			}
		},


		/* getDialog() {
			var that = this
			
			this.setWindows()

			let params = {
				claimNumber: this.claim.number
			}

			this.loading = true
			return axios.get(`/claim/dialog`, { params: params }).then(response => {
				//console.log(that.$options.name, 'getDialog', 'response.data', response.data)

				that.setWindows(response.data?.windows ? response.data.windows : null)
			}, error => {
				//console.log('error', error)
				this.showMessage(error)
			}).finally(() => {
				this.loading = false
			});
		}, */

		/* saveWindow(window) {
			if(window) {
				if(window.component == 'Picture') {
					return this.savePicture(window)
				}

				if(window.component == 'Document') {
					return this.uploadDocument(window)
				}

				var that = this
				this.loading = true
				return axios.post(`/claim/dialog`, window).then(response => {
					//console.log(that.$options.name, 'onNext','response.data', response.data)
					window.changed = false
					that.nextStep()
				}, error => {
					//console.log('error', error)
					this.showMessage(error)
				}).finally(() => {
					this.loading = false
				});
			}
		}, */

		uploadDocument(element) {
			//console.log(this.$options.name, 'uploadDocument','element', element)
			//console.log(this.$options.name, 'uploadDocument','claim', this.claim)

			let formData = new FormData();
			formData.append('number', this.claim.number);
			formData.append('code', element.code);
			formData.append('role', this.claim?.applicant?.role?.code ? this.claim.applicant.role.code : 'injured');

			let files = element?.files;
			if(files) {
				files.forEach((item, index) => {
					formData.append(`file${index}`, item.file);
				})
			}

			var that = this
			this.loading = true
			return axios.post(`/claim/document`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			}).then(response => {
				//console.log(that.$options.name, 'uploadDocument','response.data', response.data)

				let documentTypeCode = response.data?.type?.code
				if(documentTypeCode) {
					let document = that.claim.documents.find((document) => document.type.code === documentTypeCode)
					if(!document) {
						that.claim.documents.push(response.data)
					}
				}

				element.changed = false
				//that.nextStep()
			}, error => {
				console.log('error', error)
				this.showMessage(error)
			}).finally(() => {
				this.loading = false
			});
		},

		/* savePicture(window) {
			//console.log(this.$options.name, 'savePicture','window', window)

			let formData = new FormData();
			formData.append('code', window.code);
			formData.append('name', window.name);
			formData.append('claimNumber', this.claim.number);

			window.files.forEach((item, index) => {
				formData.append(`file${index}`, item.file);
			})

			var that = this
			this.loading = true
			axios.post(`/claim/picture`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			}).then(response => {
				//console.log(that.$options.name, 'savePicture','response.data', response.data)
				window.changed = false
				that.nextStep()
			}, error => {
				//console.log('error', error)
				this.showMessage(error)
			}).finally(() => {
				this.loading = false
			});
		}, */


		getImageCount(element) {
			//console.log(this.$options.name, 'getImageCount','element', element)
			return element?.files?.length
		},
		
		onPrevious() {
			this.previousStep()
		},

		onNext() {
			//console.log(this.$options.name, 'onNext')

			var that = this

			//Тимчасово. Для прискориного тестування
			//this.step++
			//return;
			let element = this.elements[this.step];
			if(element) {
				const mandatory = element?.mandatory ? element.mandatory : false
				const save 		= element?.save ? element.save : false

				//console.log(this.$options.name, 'onNext','window.code', window.code)
				//console.log(this.$options.name, 'onNext','$refs', this.$refs)
				//console.log(this.$options.name, 'onNext','mandatory', mandatory, 'save', save)

				this.$refs[element.code][0].validate?.().then(({ valid: isValid }) => {
					//console.log(this.$options.name, 'onNext','isValid', isValid)

					if(isValid) {
						//console.log(this.$options.name, 'onNext','window', window)
						//console.log(this.$options.name, 'onNext','element', element)

						if(element?.changed !== false) {
							if(save) {
								//this.loading = true
								this.save(element).then(() => {
									//this.loading = false
									this.nextStep()
								})
							} else this.nextStep()
						} else this.nextStep()
					} else {
						if(!mandatory) this.nextStep()
					}
				})
			}

			/* let window = this.windows[this.step];
			if(window) {
				const mandatory = window?.mandatory ? window.mandatory : false

				//console.log(this.$options.name, 'onNext','window.code', window.code)
				//console.log(this.$options.name, 'onNext','$refs', this.$refs)

				this.$refs[window.code][0].validate?.().then(({ valid: isValid }) => {
					if(isValid) {
						//console.log(this.$options.name, 'onNext','window', window)

						if(window?.changed !== false) {
							this.saveWindow(window)
						} else {
							this.nextStep()
						}
					} else {
						if(!mandatory) this.nextStep()
					}
				})
			} */
		},

		/* onSummary() {
			this.checking()
			this.onStep('Summary')
		}, */

		/* onSummary() {
			let step = this.windows.findIndex((element) => element.code == 'Summary')
			if(step >= 0) {
				this.setStep(step)
			}
		}, */


		/**
		 * Перевірка даних
		 */
		checking() {
			//console.log(this.$options.name, 'checking')
			this.elements.forEach((element) => {
				if(element?.required) {
					switch(element.code) {
						case '': break;
						default: 
							/* if(this.data.hasOwnProperty(element.code)) {
								if(Array.isArray(this.data[element.code])) {
									if(this.data[element.code].length == 0) {
										element.errors.push('Відсутні фото')
									}
								}
							} */
					}
				}
			});
		},

		validate() {
			// Очистка помилок
			this.elements.forEach((element) => element.errors = []);
			
			//this.checking()

			for (const [refName, value] of Object.entries(this.$refs)) {
				//console.log(this.$options.name, 'validate', 'refName', refName, 'value', value)
				//console.log(this.$options.name, 'validate', `${key}: ${value}`);
				let element = this.elements.find((element) => element.code == refName);
				//element.errors = [];

				for (const [i, item] of Object.entries(value)) {
					//console.log(this.$options.name, 'validate', 'i', i, 'item', item)
					if(item.validate?.()) {
						item.validate().then(({ valid, error }) => {
							//console.log(this.$options.name, 'validate', 'refName', refName, 'valid', valid)
							if(!valid) {
								//element.errors.push({ valid, error})
								element.errors.push(error)
							}
						})
					}
				}
			}

			//console.log(this.$options.name, 'validate', 'valids', valids)
			//console.log(this.$options.name, 'validate', 'windows', this.windows)

		},
	},
}
</script>
